import { useState, useEffect } from 'react';

// ---------------------------------------------------------------------------
// Global synchronized slideshow timer.
// A single shared interval drives every slideshow on the page (product cards
// and category cards) so they all advance to the next slide at the EXACT
// same moment.
// ---------------------------------------------------------------------------
export const SLIDE_INTERVAL_MS = 3500;

let globalTick = 0;
let intervalStarted = false;
const tickListeners = new Set();

function ensureGlobalTimer() {
  if (intervalStarted) return;
  intervalStarted = true;
  setInterval(() => {
    globalTick += 1;
    tickListeners.forEach((fn) => fn(globalTick));
  }, SLIDE_INTERVAL_MS);
}

export function useSyncedTick() {
  const [tick, setTick] = useState(globalTick);
  useEffect(() => {
    ensureGlobalTimer();
    const listener = (t) => setTick(t);
    tickListeners.add(listener);
    return () => tickListeners.delete(listener);
  }, []);
  return tick;
}
